import { render } from "./RecentProject.vue?vue&type=template&id=1648a99c&scoped=true"
import script from "./RecentProject.vue?vue&type=script&lang=js"
export * from "./RecentProject.vue?vue&type=script&lang=js"

import "./RecentProject.vue?vue&type=style&index=0&id=1648a99c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1648a99c"

export default script